import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "verified",
  "use": "verified-usage",
  "viewBox": "0 0 400 400",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 400 400\" id=\"verified\"><defs><style>#verified .cls-1{fill:none;stroke:#3c4859;stroke-linecap:round;stroke-linejoin:round;stroke-width:13px}</style></defs><path class=\"cls-1\" d=\"M166.5 205.71l21.13 21.22 49.87-49.86\" /><circle class=\"cls-1\" cx=\"200\" cy=\"200\" r=\"113.54\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol